import { connect } from 'react-redux'

import SearchResultHeader from './searchResultHeader'

const mapStateToProps = state => {
  const { common: { currentSite }, user: { preferences } } = state

  return {
    currentSite,
    preferences
  }
}

const SearchResultHeaderContainer = connect(mapStateToProps)(SearchResultHeader)

export default SearchResultHeaderContainer
